var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      staticClass: "small",
      attrs: {
        title: _vm.$t("quotaConfirm.title"),
        showMask: _vm.showMask,
        leftBtnTxt: _vm.$t("quotaConfirm.noOperate", { operate: _vm.operate }),
        leftBtnClick: _vm._cancel,
        rightBtnTxt: _vm.$t("quotaConfirm.goQuota"),
        rightBtnClick: _vm._submit
      }
    },
    [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.$t("quotaConfirm.cancelContent", { operate: _vm.operate })
          ) +
          "\n"
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }